export const HEAD_HEIGHT = 85;
export const MENU_WIDTH_XL = 350;
export const CONTENT_PT_PB = 30;
export const CONTENT_PL_PR = 40;
